import React, { useMemo } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import omit from "lodash/omit";
import classnames from "classnames";
import styles from "./nav-button.module.scss";

export const NavButton: React.FC<{ to: string; className: ({ isActive }: { isActive: boolean }) => string; children?: React.ReactNode }> =
  React.forwardRef<HTMLDivElement, { to: string; className: ({ isActive }: { isActive: boolean }) => string; children?: React.ReactNode }>(
    (props, ref) => {
      const navigate = useNavigate();
      const location = useLocation();

      const isActive = useMemo(() => {
        return location.pathname === props.to;
      }, [location, props.to]);
      return (
        <div
          {...omit(props, [`className`, `to`])}
          ref={ref}
          onClick={() => navigate(props.to)}
          className={classnames(styles.navButton, props.className({ isActive }))}
        >
          {props.children}
        </div>
      );
    }
  );
